import React from "react";

import Button from "../../Common/FormElements/Button/Button";
import { useTranslation } from "react-i18next";
import CalendarInput from "../../Common/FormElements/CalendarInput/CalendarInput";

const FactureFilters = ({ handleChange, handleSearch }) => {
  const { t } = useTranslation("common");

  return (
    <div className="d-flex flex-column">
      <div className="d-flex justify-content-between gap-4">
        <div className="w25 d-flex flex-column">
          <label className="f16 text-softBlack mb-2 sBold">{t("From")}</label>
          <CalendarInput
            name="from"
            className="w100"
            minDate={false}
            callback={(event) => handleChange(event)}
          />
        </div>
        <div className="w25 d-flex flex-column">
          <label className="f16 text-softBlack mb-2 sBold">{t("To")}</label>
          <CalendarInput
            name="to"
            className="w100"
            minDate={false}
            callback={(event) => handleChange(event)}
          />
        </div>
        <div className="w25"></div>
        <div className="w25"></div>
      </div>
      <div className="d-flex justify-content-between mt-4 gap-4">
        <div className="w25"></div>
        <div className="w25"></div>
        <div className="w25"></div>
        <div className="w25 d-flex justify-content-end align-items-end">
          <div className="w100">
            <Button className="w100" onClick={handleSearch}>
              {t("Filter")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FactureFilters;
